var utils = require('../../utils')
import AppHeader from '../AppHeader'
import $ from "jquery"
global.jQuery = $;
window.jQuery = $;
export default {
  name: 'magazine-new',
  created () {
  },
  data () {
    return {
      canValidate: true,
      savingFlag: false,
      magazine_ym_y: (new Date).getFullYear(),
      magazine_ym_m: ((new Date).getMonth() + 1),
      magazine: {
        magazine_title: null,
        magazine_ym: null,
        magazine_picture: null,
        magazine_pdf: null
      }
    }
  },
  computed: {
    validation: function() {
      var v = {
        magazine_title: !!this.magazine.magazine_title,
        magazine_picture: !!this.magazine.magazine_picture,
        magazine_pdf: !!this.magazine.magazine_pdf,
        not_input: !!this.magazine.magazine_title &&
                   !!this.magazine.magazine_picture &&
                   !!this.magazine.magazine_pdf
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    },
    getMagazineYm() {
      this.magazine.magazine_ym = (this.magazine_ym_y * 100) + this.magazine_ym_m
    },
    getMagazineYears() {
      var ret = []
      var counts = 11
      for (var i=0; i<counts; i++) {
        var dt = new Date()
        dt.setFullYear(dt.getFullYear() + i - 10)
        ret.push(dt.getFullYear())
      }
      return ret
    }
  },
  components: {
    AppHeader
  },
  methods: {
    selectedMagazinePicture: function (event) {
      if (event) {
        var files = event.target.files
        this.magazine.magazine_picture = files[0]
      }
    },
    selectedMagazinePdf: function (event) {
      if (event) {
        var files = event.target.files
        this.magazine.magazine_pdf = files[0]
      }
    },
    onClickCancel: function () {
      this.$router.push({ path: '/magazines', query: { type: this.$router.currentRoute.query.type}})
    },
    onClickSave: function () {
      if (this.savingFlag) return false
      var data = {}
      this.canValidate = true
      if (this.isValid) {
        this.savingFlag = true
        var form = new FormData()
        form.append('magazine_title', this.magazine.magazine_title)
        form.append('magazine_ym', this.magazine.magazine_ym)
        form.append('magazine_picture', this.magazine.magazine_picture)
        form.append('magazine_pdf', this.magazine.magazine_pdf)
        this.$store.dispatch('MAGAZINE_CREATE', {
          data: form,
          callback: this.onSaved
        })
      } else {
        console.log("need edit")
      }
    },
    onSaved: function (result) {
      this.savingFlag = false
      this.$router.push('/magazines')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/magazine-new.js